<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="700px" :before-close="handleClose" @close="handleClose"
      v-if="dialogVisible">
      <div v-loading="loading">
        <div class="flex-center-between account-item pointer" v-for="(item, index) in accountData" :key="index"
             @click="handleLogin(item)" :class="item.type != 1 && item.status == '0' ? 'disabled' : ''">
          <div>{{ item.name || item.businessName }}</div>
          <div class="flex-center">
            <img class="mr15" v-if="item.type == 1" src="@/assets/user/personal-authentication.png" style="height: 20px" alt />
            <img class="mr15" v-if="item.type != 1 && item.status != '0'" src="@/assets/user/enterprise-certification.png" style="height: 20px" alt />
            <div class="mr15" v-if="item.type != 1 && item.status == '0'">认证中</div>
            <!-- <img v-if="item.type==2" src alt /> -->
            <i class="el-icon-right"></i>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      accountData: []
    };
  },
  methods: {
    getBusinessList(){
      this.$http.get(this.$api.authentication.getBusinessList).then(res => {
        if (res.data.code == '200'){
          let accountData = res.data.data.onlineBusinesses
          accountData.unshift({
            name: res.data.data.onlineUser.name,
            type: 1
          })
          this.accountData = accountData
          this.loading = false
        }
      })
    },
    show(title) {
      this.title = title
      this.loading = true
      this.getBusinessList()
      // this.accountData = JSON.parse(this.$auth.getAccount())
      this.dialogVisible = true;
    },
    handleLogin(param) {
      if (param.status == '0') return

      let spaceType = ''
      if (param.businessName) {
        spaceType = 'business'
      } else {
        spaceType = 'personal'
      }
      let params = {
        spaceType: spaceType,//"personal" or "company"
        businessId: param.id
      }
      this.$http.post(this.$api.login.chooseSpace, params).then(res => {
        // this.$auth.setToken(res.data.token);
        this.getInfo(params.spaceType)
      })
      // this.$auth.setUserId(res.data.user.userId);
    },
    getInfo(type) {
      this.$http.get(this.$api.user.getInfo).then(res => {
        //判断登录类型是个人还是企业，用户账户信息中基本信息的展示
        let temp = res.data.data
        if (type == 'personal') {
          temp.type = 1
        } else {
          temp.type = 2
        }
        this.$store.commit("account/setUser", temp);
        this.handleClose()
        this.$router.push({
          path: "/home",
        });
      })
    },
    handleClose() {
      this.loading = false;
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.account-item {
  padding: 15px 20px 15px 10px;
  border-bottom: 1px solid #eee;
  // &:hover {
  //   color: #407fff;
  //   background: #407fff;
  //   opacity: 0.1;
  // }
}

.disabled{
  background-color: #f5f7fa;
}

::v-deep .el-dialog__header {
  text-align: center !important;
}
</style>
